module.exports = __webpack_public_path__ + "img/corner-right-up.069ad273.svg";